import React from 'react'
import { Changelog, useInfoPanelContext } from '../../../../InfoPanel'
import { ReactComponent as ChangelogIcon } from '../../../Icons/assets/changelog-icon.svg'
import { Tooltip } from '../../Tooltip'
import { IconButton, IconButtonVariant } from '../IconButton'

export const ChangelogButton = ({
  subjectModelIds,
  subjectIds,
  tooltipPlacement = 'top',
}: {
  subjectModelIds?: string[]
  subjectIds?: string[]
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
}): JSX.Element => {
  const { setInfoPanelState } = useInfoPanelContext()

  return (
    <Tooltip
      id={`changelog-tooltip-${subjectModelIds}`}
      placement={tooltipPlacement}
      tooltipBody="Activities"
    >
      <IconButton
        variant={IconButtonVariant.icon}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setInfoPanelState({
            isShown: true,
            render: (
              <Changelog
                subjectmodelids={subjectModelIds}
                subjectIds={subjectIds}
              />
            ),
          })
        }}
      >
        <ChangelogIcon width="24px" height="24px" />
      </IconButton>
    </Tooltip>
  )
}
